let Api = {
	// 品质评价
	"EVALUATION_LIST": "/quality/w/evaluation/findPageList", //评价项目管理列表查询
	"EVALUATION_INFO": "/quality/w/evaluation/findInfo", //查看详情
	"EVALUATION_SAVE": "/quality/w/evaluation/saveOrUpdate", //分类列表（品质评价）
	"EVALUATION_DEL": "/quality/w/evaluation/delEvaluationProject", //删除记录

	"MEMBPAGELIST": "/system/w/platMemb/findMembPageList", //申请企业
}
module.exports = Api